export const iconFontAwesomeArrowsShuffle = (
	<i className="fa-solid fa-shuffle"></i>
);
